<template>
  <button class="icon-button" @click="toggleSettings">
    <div class="tooltipContainer">
      <div class="icon-settings toolbarIconContainer" :style="transparentColor">
        <IconBase
          iconColor="#111"
          viewBox="0 0 24 24"
          width="100%"
          height="100%"
          strokeWidth="0.7px"
          ><IconSettings />
        </IconBase>
      </div>
      <div class="tooltipElement settingsTooltip">
        <span class="tooltipTip">Settings</span>
        <span class="tooltipShortcut">ALT+S</span>
      </div>
    </div>
  </button>
</template>

<script>
import IconBase from "../../../../../components/IconBase";
import IconSettings from "../../../../../components/SVG/IconSettings";

import { transparentColor } from "../../SessionHelpers/colors";

export default {
  name: "SettingsToggle",
  components: {
    IconBase,
    IconSettings,
  },
  methods: {
    toggleSettings() {
      this.$store.dispatch("toolbar/toggleToolbar", "settings");
    },
  },
  computed: {
    transparentColor() {
      return transparentColor();
    },
  },
};
</script>

<style scoped>
@import "../../SessionStyles/Icon.css";
@import "../../SessionStyles/Tooltip.css";

.settingsTooltip {
  top: 52px;
  bottom: 0;
  margin-left: 43.5px;
  margin-right: 43.5px;
}
</style>